module.exports = __webpack_public_path__ + "static/img/05么么哒.b92a2c8.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/im/emoji/05么么哒.gif
// module id = qFWP
// module chunks = 0